import { render, staticRenderFns } from "./PdfVista.vue?vue&type=template&id=25161105"
import script from "./PdfVista.vue?vue&type=script&lang=js"
export * from "./PdfVista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports